import { Container, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import Header from './Header';

const Mobile: React.FC = () => (
  <Container
    maxW="xl"
    d={{ base: 'flex', desktop: 'none' }}
    flexDir="column"
    px={0}
  >
    <Header mb={500} />
    <Heading size={300} isLight as="h3">
      Before
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      This weathered Northeastern home was ready for a complete refresh.
    </Heading>
    <StaticImage
      placeholder="blurred"
      alt="Rendering"
      src="../../../assets/images/rendering_personalized_1.jpg"
    />
    <Heading size={300} isLight as="h3">
      Rendering
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      With HOVER, it was easy to visualize and sell premium architectural
      details that increased the project scope by thousands of dollars.
    </Heading>
    <StaticImage
      placeholder="blurred"
      alt="Rendering"
      src="../../../assets/images/rendering_personalized_2.jpg"
    />
    <Heading size={300} isLight as="h3">
      After
    </Heading>
    <Heading size={200} isDisplay marginBottom={700} as="p">
      The result is a beautiful home transformation that delivered on the
      homeowner&apos;s vision.
    </Heading>
    <StaticImage
      placeholder="blurred"
      alt="Rendering"
      src="../../../assets/images/rendering_personalized_3.jpg"
    />
  </Container>
);

export default Mobile;
